import { MultiSelect as MantineMultiSelect, MultiSelectProps } from '@mantine/core';

import { FieldCaption } from '../FieldCaption';
import compactClasses from '../compactField.module.css';

import classes from './MultiSelect.module.css';

type Props = {
	caption?: string;
	/** Компактный вариант для десктопных фильтров и форм админки */
	compact?: boolean;
} & MultiSelectProps;

export const MultiSelect = ({ caption, compact = false, ...rest }: Props) => {
	return (
		<MantineMultiSelect
			classNames={
				compact
					? {
							root: compactClasses.root,
							input: compactClasses.multiInput,
							label: compactClasses.label,
							dropdown: compactClasses.dropdown,
						}
					: classes
			}
			label={<FieldCaption compact={compact}>{caption}</FieldCaption>}
			{...(compact && { size: 'sm' })}
			{...rest}
		/>
	);
};
